module.exports = new __parcel__URL__("alert-circle-outline.7f9e119f.svg").toString();